export default function Contact() {
    return (
      <>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "100vh",
          }}
        >
          <div style={{ marginTop: "15vh", marginBottom: "15vh" }}>
            <iframe
              title="Contact Form"  // Added unique title for accessibility
              src="https://docs.google.com/forms/d/e/1FAIpQLSdlVz8oO21XLaMvRTofLsJ2Hrb6UuJZD0eWp26MDFjCN4qYhA/viewform?embedded=true"
              width="400"
              height="1050"
              frameBorder="0"
              marginHeight="0"
              marginWidth="0"
            >
              Loading…
            </iframe>
          </div>
        </div>
      </>
    );
  }
  